module.exports = __webpack_public_path__ + "static/media/view-icon-opeq-bg.a490e47c.svg";